import _ from 'lodash'

import {
  DELETE_ACTION,
  UPDATE_FLOW_HISTORY,
  CREATE_STEP,
  DELETE_STEP,
  UPDATE_STEP_NAME,
  ADD_ACTION,
  UPDATE_ACTION,
  FETCH_FLOW_DONE,
  SAVE_FLOW_SUCCESS,
  SAVE_AND_PUBLISH_FLOW_SUCCESS,
  UPDATE_ACTIONS_ORDER,
  UPDATE_CHOICES_ORDER,
  INIT_FLOW_PAGE,
  FETCH_FLOW,
  UNSET_ACTIVE_FLOW,
  UPDATE_BOT_RESPONSE_SETTINGS,
  SHOW_UNSAVE_MESSAGE,
  HIDE_UNSAVE_MESSAGE
} from 'Actions/flow'

const initialState = {
  isFetchingFlow: false,
  isHavingUnsavedChanges: false,
  flow: {}
}

const reOrderArray = (arr, sourceIndex, destinationIndex) => {
  const orderedArray = [...(arr || [])]
  const [removed] = orderedArray.splice(sourceIndex, 1)
  orderedArray.splice(destinationIndex, 0, removed)

  return orderedArray
}

// act -> action, renamed here to avoid naning conflicts with action in a flows
const app = (state = initialState, act) => {
  const payload = act.payload || {} // payload should always be an object

  let flow
  let actions, actionId
  let stepId, steps, step, stepName
  let setting, settings

  switch (act.type) {
    case UNSET_ACTIVE_FLOW:
    case INIT_FLOW_PAGE: {
      return {
        ...state,
        isHavingUnsavedChanges: false,
        flow: {}
      }
    }

    case FETCH_FLOW: {
      return {
        ...state,
        isFetchingFlow: true
      }
    }

    case FETCH_FLOW_DONE:
      return {
        ...state,
        isFetchingFlow: false,
        flow: payload
      }

    case UPDATE_FLOW_HISTORY:
      return {
        ...state,
        history: payload
      }

    case ADD_ACTION:
      stepId = payload.stepId
      actionId = payload.actionId
      setting = payload.setting

      flow = _.get(state, 'flow', {})

      steps = _.get(flow, 'conversation.steps', {}) || {}
      step = steps[stepId] || {}
      actions = step.actions || []
      settings = step.settings || {}

      return {
        ...state,
        flow: {
          ...flow,
          conversation: {
            ...flow.conversation,
            steps: {
              ...steps,
              [stepId]: {
                ...step,
                actions: [...actions, actionId],
                settings: {
                  ...settings,
                  [actionId]: setting
                }
              }
            }
          }
        }
      }

    case UPDATE_ACTION:
      stepId = payload.stepId
      actionId = payload.actionId
      setting = payload.setting

      flow = _.get(state, 'flow', {})

      steps = _.get(flow, 'conversation.steps', {}) || {}
      step = steps[stepId] || {}
      settings = step.settings || {}

      return {
        ...state,
        flow: {
          ...flow,
          conversation: {
            ...flow.conversation,
            steps: {
              ...steps,
              [stepId]: {
                ...step,
                settings: {
                  ...settings,
                  [actionId]: setting
                }
              }
            }
          }
        }
      }

    case DELETE_ACTION:
      stepId = payload.stepId
      actionId = payload.actionId

      flow = _.get(state, 'flow', {})

      steps = _.get(flow, 'conversation.steps', {}) || {}
      step = steps[stepId] || {}
      actions = step.actions || []
      settings = step.settings || {}

      return {
        ...state,
        flow: {
          ...flow,
          conversation: {
            ...flow.conversation,
            steps: {
              ...steps,
              [stepId]: {
                ...step,
                actions: _.filter(actions, (id) => id !== actionId),
                settings: _.omit(settings, [actionId])
              }
            }
          }
        }
      }

    case UPDATE_ACTIONS_ORDER: {
      stepId = payload.stepId
      const { sourceIndex, destinationIndex } = payload

      flow = _.get(state, 'flow', {})

      steps = _.get(flow, 'conversation.steps', {}) || {}
      step = steps[stepId] || {}

      return {
        ...state,
        flow: {
          ...flow,
          conversation: {
            ...flow.conversation,
            steps: {
              ...steps,
              [stepId]: {
                ...step,
                actions: reOrderArray(step.actions, sourceIndex, destinationIndex)
              }
            }
          }
        }
      }
    }

    case UPDATE_CHOICES_ORDER: {
      stepId = payload.stepId
      const { actionId, sourceIndex, destinationIndex } = payload

      flow = _.get(state, 'flow', {})

      steps = _.get(flow, 'conversation.steps', {}) || {}
      step = steps[stepId] || {}

      return {
        ...state,
        flow: {
          ...flow,
          conversation: {
            ...flow.conversation,
            steps: {
              ...steps,
              [stepId]: {
                ...step,
                settings: {
                  ...step.settings,
                  [actionId]: {
                    ...step.settings[actionId],
                    choices: reOrderArray(step.settings[actionId].choices, sourceIndex, destinationIndex)
                  }
                }
              }
            }
          }
        }
      }
    }

    case CREATE_STEP: {
      stepId = payload.stepId
      stepName = payload.stepName
      const { internalName } = payload

      flow = _.get(state, 'flow', {})

      steps = _.get(flow, 'conversation.steps', {}) || {}
      step = steps[stepId] || {}

      return {
        ...state,
        flow: {
          ...flow,
          conversation: {
            ...flow.conversation,
            steps: {
              ...steps,
              [stepId]: {
                name: stepName,
                internal_name: internalName
              }
            }
          }
        }
      }
    }

    case DELETE_STEP: {
      const { stepId } = payload
      const flow = _.get(state, 'flow', {})
      const steps = _.get(flow, 'conversation.steps', {}) || {}
      const modifiedSteps = { ...steps }
      delete modifiedSteps[stepId]

      const history = _.get(state, 'history', '')
      const historyIndex = history.indexOf(`.${stepId}`)
      const modifiedHistory = history.substring(0, historyIndex)

      return {
        ...state,
        history: modifiedHistory,
        flow: {
          ...flow,
          conversation: {
            ...flow.conversation,
            steps: {
              ...modifiedSteps
            }
          }
        }
      }
    }

    case UPDATE_STEP_NAME: {
      const { stepId, stepName } = payload
      const flow = _.get(state, 'flow', {})
      const steps = _.get(flow, 'conversation.steps', {}) || {}
      const step = _.get(flow, `conversation.steps[${stepId}]`, {}) || {}

      return {
        ...state,
        flow: {
          ...flow,
          conversation: {
            ...flow.conversation,
            steps: {
              ...steps,
              [stepId]: {
                ...step,
                name: stepName
              }
            }
          }
        }
      }
    }

    case SAVE_FLOW_SUCCESS: {
      return {
        ...state,
        flow: {
          ...state.flow,
          conversation: {
            ...state.flow.conversation,
            id: null
          }
        }
      }
    }

    case UPDATE_BOT_RESPONSE_SETTINGS: {
      const dataToBePosted = {
        ...state,
        flow: {
          ...state.flow,
          conversation: {
            ...state.flow.conversation
          },
          settings: {
            ...state.flow.settings,
            botResponseSettings: { ...payload }
          }
        }
      }
      return dataToBePosted
    }

    case SAVE_AND_PUBLISH_FLOW_SUCCESS: {
      const { latestPublishedRevision } = payload

      return {
        ...state,
        flow: {
          ...state.flow,
          latest_published_revision: latestPublishedRevision,
          conversation: {
            ...state.flow.conversation,
            id: latestPublishedRevision
          }
        }
      }
    }

    case SHOW_UNSAVE_MESSAGE:
    case HIDE_UNSAVE_MESSAGE: {
      const { isUnsaved } = payload
      return { ...state, isHavingUnsavedChanges: isUnsaved }
    }

    default:
      return state
  }
}

export default app
